var _rect, _rect2, _rect3, _rect4, _rect5, _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddHole = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 34.5,
    width: 27,
    height: 27,
    transform: "rotate(-90 7.5 34.5)",
    stroke: "#737478",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 36.5,
    width: 5,
    height: 5,
    transform: "rotate(-90 31.5 36.5)",
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 10.5,
    width: 5,
    height: 5,
    transform: "rotate(-90 31.5 10.5)",
    fill: "white",
    stroke: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 36.5,
    width: 5,
    height: 5,
    transform: "rotate(-90 4.5 36.5)",
    fill: "white",
    stroke: "#2C3038"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 5,
    transform: "rotate(-90 4.5 10.5)",
    fill: "white",
    stroke: "#2C3038"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_927_7598",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 25L16 7L26 7L26 25L16 25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25L16 7L26 7L26 25L16 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25H14V27H16V25ZM26 25V27L28 27V25H26ZM18 25L18 7H14L14 25H18ZM24 7L24 25L28 25L28 7L24 7ZM26 23H16V27H26V23Z",
    fill: "#2C3038",
    mask: "url(#path-6-inside-1_927_7598)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L20 2L20 20.3333L21 22L22 20.3333L22 2Z",
    fill: "#F87B0E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddHole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addHole.8267652e810f8737bc086eb9536ed00c.svg";